/**
 * Business segments — the universes EGBA prospects.
 *
 * A segment is what the company *is* (a private school, a corporation that must
 * publish its balance sheet), not what it bought. It lives here, shared, so the
 * import that writes it, the filter that reads it and the label the operator
 * sees can never drift apart — three copies of this list would eventually
 * disagree, and the screen would filter on a value that no row carries.
 *
 * The CNAE codes are the Receita Federal's, and they are what defines the
 * universe: 8520-1/00 is secondary education, 8541-4/00 is technical
 * professional education at secondary level. Those two are the schools that owe
 * the concluintes publication under Res. CEE 44/2020.
 */

export interface Segmento {
  id: string
  nome: string
  descricao: string
  /** What the operator is buying, in one line — used on the import screen. */
  obrigacao: string
  cnaePrincipal?: string[]
  cnaeSecundarioContem?: string[]
  naturezaJuridicaContem?: string[]
}

export const SEGMENTOS: readonly Segmento[] = [
  {
    id: 'escola_particular',
    nome: 'Escola particular',
    descricao: 'Ensino Médio e Educação Profissional Técnica de Nível Médio',
    obrigacao:
      'Precisa publicar a relação de concluintes no Diário Oficial — Resolução CEE nº 44/2020, Art. 4º. Na rede privada o ônus é da própria escola (§ 1º).',
    cnaePrincipal: ['8520100', '8541400'],
    cnaeSecundarioContem: ['8520100', '8541400'],
  },
  {
    id: 'empresa_balanco',
    nome: 'Empresa que publica balanço',
    descricao: 'S.A., cooperativas, fundações, estatais e consórcios',
    obrigacao:
      'Precisa publicar demonstrações financeiras — art. 289 da Lei 6.404/76, na redação da Lei 13.818/2019.',
    naturezaJuridicaContem: [
      'Anônima',
      'Cooperativa',
      'Fundação',
      'Economia Mista',
      'Empresa Pública',
      'Consórcio',
    ],
  },
]

export function segmentoPorId(id: string | null | undefined): Segmento | undefined {
  return SEGMENTOS.find((s) => s.id === id)
}

/** Human label, with a safe fallback for a segment recorded by an older import. */
export function nomeDoSegmento(id: string | null | undefined): string {
  if (!id) return 'Não classificado'
  return segmentoPorId(id)?.nome ?? id
}
